import { render } from "./TransactionFreeProduct.vue?vue&type=template&id=ff86bd16&scoped=true&ts=true"
import script from "./TransactionFreeProduct.vue?vue&type=script&lang=ts"
export * from "./TransactionFreeProduct.vue?vue&type=script&lang=ts"

import "./TransactionFreeProduct.vue?vue&type=style&index=0&id=ff86bd16&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff86bd16"]])

export default __exports__